import { ProductType } from "generated/graphql";
import createSelectOptions from "utils/arrays/createSelectOptions";

const asphaltRateOptions = createSelectOptions([
  0.5, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5, 3.75, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5,
  8, 9, 10, 11, 12,
]);

const excavateOutRateOptions = createSelectOptions([
  0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 9, 10, 11, 12, 13, 14, 15,
  16, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
  43, 44, 45, 46, 47, 48,
]);

export const applicationRateMappings = {
  [ProductType.ASPHALT]: asphaltRateOptions,
  [ProductType.ASPHALT_CURBING]: asphaltRateOptions,
  [ProductType.EXCAVATE_OUT]: excavateOutRateOptions,
  ["Asphalt"]: asphaltRateOptions,
  ["Asphalt Curbing"]: asphaltRateOptions,
  ["Excavate Out"]: excavateOutRateOptions,
};
